import { DispatchWithoutAction, FC, ReactNode } from 'react';
import './DashboardReport.scss';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import ContentLoader from 'react-content-loader';

export const DashboardReport: FC<{
  title: ReactNode;
  value: ReactNode;
  icon?: ReactNode;
  onClick?: DispatchWithoutAction;
  to?: string;
  active?: boolean;
  loading?: boolean;
}> = ({ title, value, onClick, to, active, icon, loading }) => {
  let content: JSX.Element;

  if (loading) {
    content = (
      <ContentLoader viewBox="0 0 80 65" style={{ maxWidth: 80, height: 65 }}>
        <rect x="0" y="0" rx="2" ry="2" width="80" height="21" />
        <rect x="0" y="29" rx="2" ry="2" width="60" height="36" />
      </ContentLoader>
    );
  } else {
    content = (
      <>
        <header className="header">
          <div className="title">{title}</div>

          {icon ? <div className="icon">{icon}</div> : null}
        </header>

        <div className="value">{value}</div>
      </>
    );
  }

  return onClick ? (
    <button
      className={classNames('DashboardReport -clickable', {
        '-active': active,
      })}
      onClick={onClick}
    >
      {content}
    </button>
  ) : to ? (
    <Link className="DashboardReport -clickable" to={to}>
      {content}
    </Link>
  ) : (
    <div className="DashboardReport">{content}</div>
  );
};
